var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatSettingsLine = function SvgChatSettingsLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 12h-1.8V5.7H4.8v12.047L6.387 16.5H12v1.8H7.01L3 21.45V4.8a.9.9 0 0 1 .9-.9h16.2a.9.9 0 0 1 .9.9zm-7.07 6.364a3.6 3.6 0 0 1 0-1.928l-.877-.506.9-1.559.878.507a3.6 3.6 0 0 1 1.669-.964V12.9h1.8v1.014a3.6 3.6 0 0 1 1.669.964l.878-.507.9 1.559-.878.506a3.6 3.6 0 0 1 0 1.928l.878.507-.9 1.559-.878-.507a3.6 3.6 0 0 1-1.669.964V21.9h-1.8v-1.013a3.6 3.6 0 0 1-1.669-.964l-.878.507-.9-1.559zm3.47.836a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6"
  })));
};
export default SvgChatSettingsLine;